module.exports = "<div class=\"card-header\">\r\n  <a role=\"button\" (click)=\"toggleClick($event)\">\r\n    <div class=\"row\">\r\n      <div class=\"col-11 m-0 p-0\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n      <div class=\"col-1 m-0 p-0\">\r\n        <i class=\"fa fa-angle-down rotate-icon\"></i>\r\n      </div>\r\n    </div>\r\n  </a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.head.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.head.html
// module chunks = main